import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES,useParams } from './../../common/helper/common-imports.component.js';
import DataTable from 'react-data-table-component';
import DashboardService from '../../../services/dashboard-service.js';
import ConfigService from '../../../services/config-service.js';
import { FormField, SelectField } from './../../common/helper/formFields';
import StatusBadge from '../../common/helper/transaction-status.component.js';
import { transactionSerachFormData , initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import {transactionStatus, paymentMethods, transactionType} from '../../common/helper/status-constant.js';
import SelectSearch from 'react-select-search';
import { useLocation } from 'react-router-dom';
import TicketService from '../../../services/tickets-service.js';
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
const CreateTicket = () => {
   
    const [fileUrl, setFileUrl] = useState('');
  
  const [activeTab, setActiveTab] = useState('per_details');
  const [autoGeneratePassword, setAutoGeneratePassword] = useState(true);
  const [content, setContent] = useState('');
  const maxLength = 500;
  const [errors, setErrors] = useState({ ...initialErrors });
const [subjects,setSubjects] = useState([])
  const [statesData,setStatesData] = useState([]);
  const [ticketCategories,setTicketCategories] = useState([]);
  const [category,setSelectedCategory] = useState();
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const [role,setUserRole] = useState('');
  const [status,setStatus] = useState('');
  const [modalShow, setModalShow] = React.useState(false);

  const [loading, setLoading] = useState(false);
  const [transaction , setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [distributors, setDistributors] = useState([]);
const [transactionStatsData, setTransactionStats] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [formData, setFormData] = useState({ ...transactionSerachFormData, agentTicket:true });
  const [selectedRows, setSelectedRows] = React.useState([]);

  const [advanceFilters, setAdvanceFilters] = useState([]);
  const selectRows =  React.useCallback(state => {
    setSelectedRows(state.selectedRows[0]);
}, []);

  const paginationComponentOptions = { 
    noRowsPerPage :true
  }

  const [columns, setColumns] = useState([
    {
      name: 'Order ID',
      cell: row => <div className="custom-cell-order_Code"> <a href="javascript:void(0)" onClick={() => viewTransaction(row.transaction_id)}>{row.order_code}</a></div>,
      sortable: true,
     
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => <div className="custom-cell-order_Code">{row.start_date}</div>,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      <StatusBadge status={row.status} />

      </>,
      
      sortable: true,
    },
    {
      name: 'Amount',
      selector: row => '₹' + row.amount,
      sortable: true,
    },
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
        row.payment_method && row.payment_method.toLowerCase() === 'imps' ? 'fa-money' :
                            row.payment_method && row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method && row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method && row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method || '-'}
      
      </>
      
      ,
      sortable: true,
    },
    {
      name: 'Actions',
      selector: row => <>

      <div  style={{display:'flex'}}>
      
        <a className="fview tooltip" style={{'cursor':'pointer'}} onClick={() => {
          viewTransaction(row.transaction_id);
        }}>
          <i className="fa fa-eye" />
          <span className="tooltiptext"  >View</span>
        </a>
        {row.status =='P' && ( 
          <>
        <a className="tooltip dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa fa-ellipsis-v" aria-hidden="true"  style={{color:'black'}}/>
          <span className="tooltiptext">More</span>
        </a>
        <ul className="dropdown-menu transaction dropdown-menu-end mbv" id="nvb" aria-labelledby="navbarDropdown">
          <li onClick={() => {
          confirm(row.transaction_id, row.order_code);
        }}>
            <a className="dropdown-item"  style={{cursor:'pointer',fontSize: '13px'}}>Confirm</a>
          </li>
          <li onClick={() => {
          raised(row.transaction_id, row.order_code);
        }}>
            <a className="dropdown-item"  style={{cursor:'pointer',fontSize: '13px'}}>Raised</a>
          </li>
        </ul></>
        )}
        </div>
      </>
    },
  ]);
const viewTransaction = (id) => {
  navigate(`/transaction/${id}?type=ticketTransaction`)
}

const confirm = (id,orderCode) => {
  navigate(`/confirm-transaction/${id}/${orderCode}}`)
}

const raised = (id,orderCode) => {
  navigate(`/raised-transaction/${id}/${orderCode}`)
 
}
const handleChangeSearch = (e) => {
    setFormData((prevData) => ({ ...prevData, ['agent_id']: e }));
  
  }
  const handleChangeSearchMerchant = (e) => {
    setFormData((prevData) => ({ ...prevData, ['customer_id']: e }));
  
  }

  const handleChangeSearchDistributor = (e) => {
    setFormData((prevData) => ({ ...prevData, ['distributor_id']: e }));
  
  }

  const transactionStats = () => {
    
    let transaction =  DashboardService.getTransactionStats(formData);
    setLoading(true);
    transaction.then(response => {
      console.log(response.data)
      setTransactionStats(response.data.data)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        console.log(e)
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }

  const listTransactions = (pageNumber, rowsPage, transactionData = null) => {
  
      DashboardService.setSearchTransaction(formData,pageNumber);
  
    let userRole = '';
    let transaction =  DashboardService.getSystemTransaction(transactionData ? transactionData :formData, pageNumber, rowsPage)
    if(userData.user.data) {
      userRole = userData.user.data.role
    }
    console.log(userRole)
    setUserRole(userRole)

    if(userRole == 'ADMIN') {
    //  transaction =  DashboardService.getTransactionsListAdmin()
    }
    setLoading(true);
   
    transaction.then(response => {
      console.log(response)
      const records = response.data.data.list
      
      setTotalRows(response.data.data.total_records)



      setTransactionData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
  const getAgents = () => {
    setLoading(true);
    ConfigService.getAgentsDropDown()
    .then((response) => {
      const agents = response.data.data
      const arr = [{name:'All Agents',value:''}];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].value,
          value: agents[i].key,
        })
      }
      console.log(arr);
      setAgents(arr);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }

  const getDistributors = () => {
    setLoading(true);
    ConfigService.getDistributorDropDown()
    .then((response) => {
      const agents = response.data.data
      const arr = [{name:'All Distributors',value:''}];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].value,
          value: agents[i].key,
        })
      }
      console.log(arr);
      setDistributors(arr);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }


  const getMerchantsList = (e) => {
    setLoading(true);
    ConfigService.getMerchantDropDown()
    .then((response) => {
        const merchts = response.data.data;
        const arr = [{name:'All Merchants',value:''}];
        for(var i=0; i<merchts.length; i++) {
        
            arr.push({
              name: merchts[i].value,
              value: merchts[i].key,
            })
        }
        setMerchants(arr);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }

  const getAdvanceFilterValues = (e) => {
    setLoading(true);
    ConfigService.getAdvanceFilterValues()
      .then(response => {
        const arr = []
     const filters = response.data.data
        for(var i=0; i<filters.length; i++) {
          arr.push({
            value: filters[i].code,
            label: filters[i].value,
          })
        }
        console.log(arr)
       setAdvanceFilters(arr)
       getTicketCategories();

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching:", error);
      });
  }
  const viewAgent = (row) => {
    let id=row.sender_id
    if(row.transaction_type == "PAYIN") {
      id = row.receiver_id
    }
    

navigate('/view-agent/'+id)
  }
  useEffect(() => {
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       console.log(userRole)
       setUserRole(userRole)
    }
    
    if(userRole !='ADMIN') {
    
    } else {
      const updatedColumns = [
        ...columns.slice(0, 4), // Keep the first 4 columns unchanged
        // Add new columns here
       
        ...[{
          name: 'Merchant',
          cell: row => <div className="custom-cell-order_Code">{row.transaction_type == 'PAYIN' ? row.sender_name : row.receiver_name}</div>,
          sortable: true,
         
        },
        {
          name: 'Agent',
          cell: row => <div className="custom-cell-order_Code">{row.transaction_type == 'PAYIN' ? row.receiver_name : row.sender_name}</div>,
          sortable: true,
         
        },
        {
          name: 'Agent Code',
          cell: row => (
            <div className="custom-cell-order_Code">
              {row.agent_code && row.agent_code.trim() !== '-' ? (
                <a href="javascript:void(0)" onClick={() => viewAgent(row)}>{row.agent_code}</a>
              ) : (
                '-'
              )}
            </div>
          ),
          sortable: true,
         
        }], 
        ...columns.slice(4), 
      ];
      setColumns(updatedColumns);
     
    }
    getDistributors()
      getAgents();
      getMerchantsList();
      getAdvanceFilterValues();
      document.body.style.backgroundImage = '';

    document.body.style.backgroundColor = '#f0f6fa';
    const typeValue = queryParams.get('type');
   if(typeValue == 'searchTransaction') {
      let searchTransactionData = DashboardService.getSearchTransaction();
     console.log(searchTransactionData)
      setFormData(searchTransactionData);
      listTransactions(searchTransactionData.pageNo,25,searchTransactionData);
    }
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

 
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'I':
        return 'Initiated';
      case 'A':
        return 'Completed';
      case 'AA':
        return 'Agent Accepted';
      case 'RA':
        return 'Raised';
      case 'RM':
        return 'Merchnat Raised';
      case 'F':
        return 'Failed';
      case 'R':
        return 'Rejected';
      case 'MC':
        return 'Cancelled';
        case 'E':
        return 'Expired';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = transaction && transaction.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });


      const handleRowsPerPageChange = (e) => {
        let rowsPage = Number(e.target.value)
        setRowsPerPage(rowsPage);
        setDataTableKey(prevKey => prevKey + 1);
        listTransactions(pageNo, rowsPage)
      };
   
      const handlePageChange = page => {
        let pageNumber = page - 1;
        setPageNo(pageNumber)
        listTransactions( pageNumber, rowsPerPage);
      };
      function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
      
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
      
        return `${year}-${month}-${day}`;
      }

      const validateField = (fieldName, value) => {
        const errorMessage = fieldValidation(fieldName, value);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
        return errorMessage
      };

const fetchTransaction = ()=> {
  if (new Date(formData.from_date) > new Date(formData.to_date)) {
    toast.error('From Date should not be greater than to Date');
    return;
  }
  if(formData.advanced_search_key) {
    if(!formData.advanced_search_value) {
      toast.error('Advance Filter Value is requierd');
      return;

    }
  }
    let hasErrors = false;
        let requiredFields =['merchant_order_code', 'agent_email', 'agent_mobile', 'agent_code', ];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formData[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });
        if(!hasErrors){
            listTransactions(0,25);

        }
}

  const getTicketCategories = (e) => {
    setLoading(true);
    TicketService.getSubjectAndCategory()
      .then(response => {
        console.log(response)
        const arr = []
        const filters = response.data.data
            for(var i=0; i<filters.length; i++) {
            arr.push({
                value: filters[i].category_id,
                label: filters[i].category_name,
                subjects:filters[i].subjects
            })
            }
       setTicketCategories(arr)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching:", error);
      });
  }

  const searchTransactions = (e) => {
    let requiredFields = ['advanced_search_key_ticket','advanced_search_value_ticket']
    if (!validateFields(requiredFields, formData)) return;
    listTransactions(0,25);
  }

 
const SubmitTicket= () => {
   console.log(formData)
    let requierdFields= ['category', 'subject','content'];
    if(category == 'Other') {
        requierdFields = ['category', 'subject_name','content'];
    }
    
    if (!validateFields(requierdFields, formData)) return;
   if(userData?.user?.data?.role?.role_code == 'ADMIN') {
    if (!formData.agentTicket && !formData.merchantTicket) {
       toast.error('Please select ticket for')
        return
    }
   }
    setLoading(true);
    const data = new FormData();
    let request  = {
        subject_id: formData.subject,
        updated_amount: formData.adjusted_amount,
        transaction_id: selectedRows.transaction_id,       
         utr_id: formData.utr_id,
        content: formData.content,
        category_id: formData.category,
        is_agent_assign:formData.agentTicket,
        is_merchant_assign: formData.merchantTicket

    }
    data.append('file',fileUrl);

   data.append('data', JSON.stringify(request)); 
    TicketService.createTicket(data)
      .then(response => {
        navigate('/tickets')
        toast.success(MESSAGES.TCK_CREATD)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        try {
          const errorMessage = error.response.data
          toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
        } catch (e){
          toast.error( MESSAGES.SERVER_ERROR)
        }
      });


}
 
  useEffect(() => {
    const typeValue = queryParams.get('type');

    getAdvanceFilterValues();
    if(typeValue == 'ticketTransaction') {
        let searchTransactionData = DashboardService.getSearchTransaction();
       console.log(searchTransactionData)
        setFormData(searchTransactionData);
        listTransactions(searchTransactionData.pageNo,25,searchTransactionData);
      }
    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
    }, []); 

 
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    return isValid;
  };

  const handleNext = (current,tab) => {
    console.log(selectedRows)
    if(selectedRows.length == 0) {
        toast.error('Please select transaction.')
        return
    }
    let requiredFields = [];
    switch (current) {
      case 'per_details':
        requiredFields = [];
        break;
      case 'address_details':
        requiredFields = [];
        break;
      case 'business_details':
        requiredFields = [];
        break;
      default:
        break;
    }
  
    if (!validateFields(requiredFields, formData)) return;
  
    setActiveTab(tab);
  };

  const handlePrevious = (tab) => {
    setActiveTab(tab);
  };
  const handleFileChange  = (e) => {
    const file = e.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    

    if (file && file.size <= maxSize) {
      setFileUrl(file);
    } else {
      setFileUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }

  const handleChange = (e) => {
    const { name, checked, type, value } = e.target;

    setFormData((prevData) => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
    validateField(name, value);
    
    if(name == "category") {
        const selectedOption = ticketCategories.find((opt) => opt.value == value);
        setSelectedCategory(selectedOption.label || null);

        getSubjects(value)
    }
    if(name == 'content') {
      setContent(e.target.value);

    }
   
  };
  const getSubjects = (value) => {
   
    let filterSubjects = [];
    for (let i = 0; i < ticketCategories.length; i++) {
      if (ticketCategories[i].value == value) {
        filterSubjects = ticketCategories[i].subjects; // Get subjects from the matched category
        break; // Exit the loop early once a match is found
      }
    }
    console.log(filterSubjects)
  
    // Transform the filtered subjects into the desired format
    const arr = filterSubjects.map((subject) => ({
      value: subject.subject_id,
      label: subject.subject_name,
    }));
  
    // Log the resulting array for debugging
    console.log(arr);
  
    // Update the state with the transformed array
    setSubjects(arr);
  };
  
 
  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Create Ticket</h4>
    <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
      <form method="post" id="register_form" action="#" className="merchant_form">
        <ul className="nav nav-tabs">
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'per_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_per_details">Search Transaction</a>
          </li>
          <li className="nav-item tbbtrn">
            <a className={`nav-link ${activeTab === 'address_details' ? 'active_tab1' : 'inactive_tab1'}`}  id="list_address_details">Enter Details</a>
          </li>
   
        </ul>
        <div className="tab-content" style={{marginTop: '16px'}}>
          <div className={`tab-pane ${activeTab === 'per_details' ? 'active' : 'fade'}`} id="per_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
              <div className="container col-md-12" style={{paddingTop: '10px', paddingBottom: '10px', background: 'white', float:'left'}}>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                    
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                       <FormField
                           type="text"
                           isRequierd = {false}
                           id="merchant_order_code"
                           name="merchant_order_code"
                           label="Merchant Order Code"
                           placeholder = "Merchant Order Code"
                           value={formData.merchant_order_code}
                           onChange={handleChange}
                           error={errors.merchant_order_code}
                           maxlength = {100}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                      <FormField
                           type="text"
                           isRequierd = {false}
                           id="order_code"
                           name="order_code"
                           label="Order Code"
                           placeholder = "Order Code"
                           value={formData.order_code}

                           onChange={handleChange}
                           error={errors.order_code}
                           maxlength = {100}
                        />
                    </div>
                    
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                    <FormField
                           type="email"
                           isRequierd = {false}
                           id="agent_email"
                           name="agent_email"
                           label="Agent Email"
                           placeholder = "Agent Email"
                           value={formData.agent_email}
                           onChange={handleChange}
                           error={errors.agent_email}
                           maxlength = {100}
                        />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                    <SelectField 
                       id="searchTransaction"
                       isRequierd = {false}
                       name="advanced_search_key"
                       label="Advance Filter"
                       selectedField = "Please Select"
                       value={formData.advanced_search_key}
                       onChange={handleChange}
                       error={errors.advanced_search_key}
                       options={advanceFilters}
                    />
                            
                            <span id="error_profiles_gender" className="text-danger" />
                          </div>
                    
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                       <FormField
                           type="text"
                           isRequierd = {false}
                           id="agent_mobile"
                           name="agent_mobile"
                           label="Agent Mobile"
                           placeholder = "Agent Mobile"
                           value={formData.agent_mobile}
                           onChange={handleChange}
                           error={errors.agent_mobile}
                           maxlength = {10}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="agent_code"
                           name="agent_code"
                           label="Agent Code"
                           placeholder = "Agent Code"
                           value={formData.agent_code}

                           onChange={handleChange}
                           error={errors.agent_code}
                           maxlength = {100}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="date"
                           isRequierd = {false}
                           id="from_date"
                           name="from_date"
                           label="From Date"
                           placeholder = "From Date"
                           value={formData.from_date }
                           onChange={handleChange}
                           error={errors.from_date}
                           max={getCurrentDate()}
                        />
                    </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="filter_value"
                           name="advanced_search_value"
                           label="Advance Filter Value"
                           placeholder = "Advance Filter Value"
                           value={formData.advanced_search_value}

                           onChange={handleChange}
                           error={errors.advanced_search_value}
                           maxlength = {100}
                        />
                    </div>

                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                    <SelectField 
                       id="searchTransaction"
                       isRequierd = {false}
                       name="payment_method"
                       label="Payment Method"
                       selectedField = "All Payment Methods"
                       value={formData.payment_method}
                       onChange={handleChange}
                       error={errors.payment_method}
                       options={paymentMethods}
                    />
                    </div>
                    {role == 'ADMIN' && (
                      <>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                    
                      <label>Select Distributor</label>
                     <SelectSearch search={true} options={distributors} onChange={handleChangeSearchDistributor}  value={formData.distributor_id} name="distributor_id" placeholder="All Distributors" />
                     <span class="fa fa-angle-down errspan"></span>

                     </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                          type="date"
                          isRequierd = {false}
                          id="to_date"
                          name="to_date"
                          label="To Date"
                          placeholder = "To Date"
                          value={formData.to_date}
                          onChange={handleChange}
                          error={errors.to_date}
                          max={getCurrentDate()}
                        />
                    </div>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                                        <SelectField 
                                            id="searchTransaction"
                                            isRequierd = {false}
                                            name="transaction_type"
                                            label="Transaction Type"
                                            selectedField = "All Transaction Types"
                                            value={formData.transaction_type}
                                            onChange={handleChange}
                                          //  error={errors.transaction_type}
                                            options={transactionType}
                                        />
                    </div>
                    </>
                    )}

                     {role != 'ADMIN' && (
                      <>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                        id="searchTransaction"
                        isRequierd = {false}
                        name="transaction_type"
                        label="Transaction Type"
                        selectedField = "All Transaction Types"
                        value={formData.transaction_type}
                        onChange={handleChange}
                      //  error={errors.transaction_type}
                        options={transactionType}
                    />
                    </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                          type="date"
                          isRequierd = {false}
                          id="to_date"
                          name="to_date"
                          label="To Date"
                          placeholder = "To Date"
                          value={formData.to_date}
                          onChange={handleChange}
                          error={errors.to_date}
                          max={getCurrentDate()}
                        />
                    </div>
                    </>

                     )}
                    
                    
                 
                   
                   
                  </div>
                  <div className="col-md-3" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                    <SelectField 
                       id="searchTransaction"
                       isRequierd = {false}
                       name="status"
                       label="Status"
                       selectedField = "All Status"
                       value={formData.status}
                       onChange={handleChange}
                       error={errors.status}
                       options={transactionStatus}
                    />
                    </div>
                    
                    {role == 'ADMIN' && (
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                    
                        <label>Select Merchant</label>
                       <SelectSearch search={true} options={merchants} onChange={handleChangeSearchMerchant}  value={formData.customer_id} name="customer_id" placeholder="All Merchants" />
                       <span class="fa fa-angle-down errspan"></span>

                       </div>
                    )}
                  
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <label>Select Agent</label>
                    <SelectSearch  value={formData.agent_id}  search={true} options={agents} onChange={handleChangeSearch} name="agent_id" placeholder="All Agents" />
                    <span class="fa fa-angle-down errspan"></span>

                    {/* <SelectField 
                       id="agent_id"
                       isRequierd = {false}
                       name="agent_id"
                       label="Agent"
                       selectedField = "Select Agent"
                      
                       onChange={handleChange}
                       error={errors.agent_id}
                       options={agents}
                    /> */}
                    {/* <div align="left">
                  <button type="button" name="previous_btn_amin_details" id="previous_btn_amin_details" className="btn ddfgg"  onClick={() => handlePrevious('business_details')}>View</button>
                  <button type="sumbit" name="btn_asubmit" id="btn_asubmit" className="btn ddfg">Download</button>
                </div> */}
                 </div>
                  </div>
                  <div align="left" style={{paddingTop: '20px',width:'100%',paddingBottom: '20px',float:'left'}}>
                  <button type="button" name="previous_btn_amin_details" id="previous_btn_amin_details" className="btn ddfgg"  onClick={() => fetchTransaction('fetchTransaction')}>Search</button>
                 
                </div>
                </div>
                <br />
                <ul className="nav nav-tabs" style={{float:'left',width:'100%','position':'relative'}}>
                    <li className="nav-item tbbtrn">
                        <a className="nav-link active_tab1" id="list_per_details">Transactions</a>
                       
                    </li>
                    <li className="nav-item tbbtrn" style={{right:0,marginTop:'6px','position':'absolute'}}>
                    <button type="button" name="btn_personal_details" id="btn_personal_details" className="btn ddfg "onClick={() => handleNext('per_details','address_details')}>Next</button>
                    </li>
                   
                 </ul>

                 <div className="dataTables_length" id="examplemgm_length" style={{float:'left'}}>
                                    <label>Show &nbsp;</label>
                      <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                      <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>

<DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                              selectableRows
                              selectableRowsNoSelectAll = {true}
                              selectableRowsSingle = {true}
                              onSelectedRowsChange = {selectRows}
                        />

                <div align="left" style={{paddingTop:"15px"}}>
                  {/* <button type="button" name="previous_btn_personal_details" id="previous_btn_personal_details" className="btn ddfgg" onClick={() => back('per_details')}>Back</button> */}
                  <button type="button" name="btn_personal_details" id="btn_personal_details" className="btn ddfg "onClick={() => handleNext('per_details','address_details')}>Next</button>
                </div>

                <br />
              </div>
            </div>
          </div>
          <div className={`tab-pane ${activeTab === 'address_details' ? 'active' : 'fade'}`} id="address_details">
            <div className="panel panel-default">
              <div className="panel-body" style={{padding: '0px'}}>
                <div className="container col-md-12" style={{padding: 0}}>
                    {userData?.user?.data?.role?.role_code == 'ADMIN' && (
                         <div className='form-group frm'>
                         <label className='required'>Ticket For</label>
                         <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                             <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                             <input   onChange={handleChange} type='checkbox' name='agentTicket' checked = {formData.agentTicket} style={{marginTop:0}}/>
                             Agent
                             </label>
                             <label style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                             <input   onChange={handleChange} type='checkbox' name='merchantTicket' checked = {formData.merchantTicket}  style={{marginTop:0}}/>
                             Merchant
                             </label>
                         </div>
                         </div>
                    )}
               

                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                    

                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <SelectField 
                       id="state"
                       isRequierd = {true}
                       name="category"
                       label="Category"
                       selectedField = "Select Category"

                       onChange={handleChange}
                       error={errors.category}
                       options={ticketCategories}
                    />
                     
                    </div>
                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="amount"
                           name="amount"
                           label="Amount"
                           value={selectedRows?.amount}
                          disabled={true}
                        />
                     
                    </div>
               
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="text"
                           isRequierd = {false}
                           id="utr_id"
                           name="utr_id"
                           label="UTR/RRN"
                           placeholder = "Enter UTR/RRN"
                          
                           onChange={handleChange}
                         
                           maxlength = {50}
                        />
                     
                    </div>

                    <div className="form-group frm" style={{textAlign: 'left'}}>
                      <label htmlFor="f_name" className='required'>Description</label>
                      <textarea type="text" style={{height:'100px',width:'500px'}} maxlength= {maxLength} className={`form-control ${errors.content ? 'is-invalid' : ''}`}    placeholder="Enter Description" id="first_name" name="content" onChange={handleChange}/>
                      <div style={{  marginTop: '5px', fontSize: '14px', color: '#555' }}>
                      {maxLength - content.length} characters remaining
                    </div>
                      {errors.content && <div className="invalid-feedback">{errors.content}</div>}
                    </div>
                  </div>
                  <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                  {category != 'Other' && (
                  <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                     <SelectField 
                     id="state"
                     isRequierd = {true}
                     name="subject"
                     label="Subject"
                     selectedField = "Select Subject"
                    
                     onChange={handleChange}
                     error={errors.subject}
                     options={subjects}
                  />
                    
                  </div>
                  )}
                {category == 'Other' && (
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                            type="text"
                            isRequierd = {true}
                            id="subject"
                            name="subject_name"
                            label="Subject"
                            placeholder = "Enter subject"
                            onChange={handleChange}
                            error={errors.subject_name}
                            maxlength={100}
                        />
                    
                    </div>

                )}
                 
                    
                  <div className="form-group frm" style={{textAlign: 'left'}}>
                    <FormField
                           type="number"
                           isRequierd = {false}
                           id="amount"
                           name="adjusted_amount"
                           label="Adjusted amount"
                           placeholder = "Enter adjusted amount"
                           onChange={handleChange}
                           error={errors.adjusted_amount}
                        />
                     
                    </div>
               
                    <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                  
                     <label > Upload Proof</label>
                     <br></br>
                     <input style={{width: '250px', display: 'inline'}} onChange={handleFileChange} type="file" className="form-control" id="imageInput"   name="f_name" />
                     
                  
                 </div>
                
                    
                
                  </div>
                </div>
                <br />
                <div align="left">
                  <button type="button" name="previous_btn_personal_details" id="previous_btn_personal_details" className="btn ddfgg" onClick={() => handlePrevious('per_details')}>Previous</button>
                  <button type="button" name="btn_personal_details" id="btn_personal_details" className="btn ddfg "onClick={() => SubmitTicket('address_details','business_details')}>Submit</button>
                </div>
                <br />
              </div>
            </div>
          </div>
         
        
        </div>
      </form>
    </div>
  </div>
  </div>
  );


  }

export default withAuth(CreateTicket);
